import br from "./br.json";
import en from "./en.json";

export default {
  en: { translation: en },
  br: { translation: br },
};
